import React from "react";

// please do not touch if not necessary

export default function CLabel({ text, className }) {
  return (
    <div className="flex">
      <h3
        className={`text-primary bg-primaryOpacity font-semibold px-3 py-1 rounded-md text-[14px] ${className} m-0`}
      >
        {text}
      </h3>
    </div>
  );
}
